import React from "react";
import { connect } from "react-redux";
import ReportDenuncias from "powerbi-report-component";


class DenunciasGrafico extends React.PureComponent {
  render() {
    const reporte1 = [];
    if (this.props.companyId) {
      const config1 = {};

      config1.embedUrl = `${this.props.config.embedUrl}&pageName=ReportSection60e9ab37abd6075b4363&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVNPVVRILUNFTlRSQUwtVVMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQifQ%3d%3d&filter=Denuncias/Denuncias_RutEmpresa eq '${this.props.companyId}' and Estructura_x0020_Meses_x0020_Denuncias/Denuncias_Meses eq '${this.props.range} Meses'`;
      if (!(this.props.sucursalId === "")) { config1.embedUrl += ` and Denuncias/Denuncias_BP_Sucursal eq '${this.props.sucursalId}'`; }

      config1.extraSettings = {
        filterPaneEnabled: false,
        navContentPaneEnabled: false,
        allowFullScreen: false,
      };

      const keydenuncia = `denunciasreport${new Date().getTime()}`;
      reporte1.push(<ReportDenuncias
        key={keydenuncia}
        embedType={this.props.config.embedType}
        tokenType={this.props.config.tokenType}
        accessToken={this.props.EmbedTokenPowerBi}
        embedUrl={config1.embedUrl}
        embedId={this.props.config.embedId}
        extraSettings={{
          filterPaneEnabled: config1.extraSettings.filterPaneEnabled,
          navContentPaneEnabled: config1.extraSettings.navContentPaneEnabled,
        }}

        permissions="All"
        style={{
          height: "300px",
          border: "0",
          padding: "0px",
          background: "#eee",
        }}
      />);
    }

    return (

      <React.Fragment >
        {reporte1}
      </React.Fragment>

    );
  }
}
const mapStateToProps = (state) => ({

  config: state.graficos.config,
  EmbedTokenPowerBi: state.graficos.EmbedTokenPowerBi,
  companyId: state.global.companyId,
  sucursalId: state.global.sucursalId,
  range: state.resumenEmpresa.range,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(DenunciasGrafico);

